<!-- Forgot Password Modal -->
<div id="forgotPasswordModal" class="modal fade in" role="dialog" style="display: none;">
	<div class="modal-dialog modal-sm">
		<!-- Modal content-->
		<div class="modal-content">
			<div class="modal-header">
				<button type="button" class="close" data-dismiss="modal"><i class="fa fa-times" aria-hidden="true"></i></button>
				<h4 class="modal-title">Forgot Username/Password</h4>
			</div>
			<div class="modal-body">
				<p>Enter the email linked to your Edgefinity IoT profile. We will send you a confirmation code.</p>
				<input [(ngModel)]="mEmailAddress" type="text" class="form-control input-lg" placeholder="Email Address">
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-default" data-dismiss="modal"><i class="fa fa-ban" aria-hidden="true"></i> CANCEL</button>
				<button type="button" class="btn btn-primary" data-dismiss="modal" (click)="nextClicked()"><i class="fa fa-arrow-right" aria-hidden="true"></i> SEND</button>
			</div>
		</div>
	</div>
</div>